<template>
    <div class="pagination" v-if="data.totalCnt > 0">
        <div class="wrapper">
            <a
                href="#"
                @click.prevent="goToPage(1)"
                v-if="(+this.$route.query.page || 1) !== 1"
            >
                <img src="@/assets/ic-pagination-first.png" alt="" />
            </a>
            <a
                href="#"
                @click.prevent="goToPage(+this.$route.query.page - 1)"
                v-if="(+this.$route.query.page || 1) !== 1"
                ><img src="@/assets/ic-pagination-prev.png" alt=""
            /></a>
        </div>

        <div class="wrapper num">
            <a
                href="#"
                @click.prevent="goToPage(page)"
                :class="+(this.$route.query.page || 1) === +page ? 'active' : ''"
                v-for="page of this.pagination"
                :key="page"
            >
                {{ page }}
            </a>
        </div>

        <div class="wrapper">
            <a
                href="#"
                @click.prevent="goToPage(+this.$route.query.page + 1)"
                v-if="(+this.$route.query.page || 1) < +data.totalPage"
                ><img src="@/assets/ic-pagination-next.png" alt=""
            /></a>
            <a
                href="#"
                @click.prevent="goToPage(+this.data.totalPage)"
                v-if="(+this.$route.query.page || 1) < +data.totalPage"
                ><img src="@/assets/ic-pagination-last.png" alt=""
            /></a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            default: [],
        },
    },
    data() {
        return {};
    },
    methods: {
        goToPage(page) {
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    page: page,
                },
            });
        },
    },
    computed: {
        pagination() {
            const { page, totalPage } = this.data;
            const count = 5;

            const startPage = Math.max(1, page - Math.floor(count / 2));

            let endPage = Math.min(totalPage, startPage + count - 1);
            const adjustedStart = Math.max(1, endPage - count + 1);

            const pages = [];
            for (let i = adjustedStart; i <= endPage; i++) pages.push(i);

            return pages;
        },
    },
};
</script>
